import React from "react";
// Common Components
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
// Requests
import { getLogTable } from "src/Requests/connections";
// Types
import type { ISearchParameters } from "src/Interfaces/TableInterfaces";

interface Props {
  userId: number;
}

const LogsTableModal: React.FC<Props> = ({ userId }) => {
  return (
    <TableTemplate<ISearchParameters, any>
      TableUI={({ reports, onAction }) => (
        <CommonTableUI reports={reports} onAction={onAction} />
      )}
      getDataTable={getLogTable}
      initialSearchParameters={{ userId }}
    />
  );
};

export default LogsTableModal;
